<template>
    <tbody>
        <table-row v-bind:key="key" v-for="(item,key) in parallel.items" :class-name="item.name_classroom" :amount="item.person" :teacher="item.classroom_teacher" />
    </tbody>
</template>

<script>
    import TableRow from "./TableRow";
  export default {
    name: "Parallel",
    props:['parallel'],
    components: {
      'table-row': TableRow
    }
  }
</script>

<style scoped>

</style>
